import React, { useState } from 'react';
import { IconArrowCascadeRight } from 'cdk-radial';
import './AdvancedPlans.css';
import { displaySubscriptionLocationPlanTile } from './LegacyPlans';
import { PLAN_TYPE } from '../../utils/api-pricing';

const CONSTANTS = {
  CUSTOM: 'custom'
};

const formatNumbers = value => {
  return new Intl.NumberFormat('en-us', {
    maximumFractionDigits: 20
  }).format(value);
};

export const AdvancedPlanTile = ({
  plan,
  isAsync,
  allEndpoints,
  instanceIdVersionMap,
  belongsTo
}) => {
  return (
    plan?.type?.toLowerCase()===PLAN_TYPE.ADVANCED ?
    <div className="api-dir-pkg_advance-plan-tile">
      <PlanDetails
        details={{
          type: plan.plan !== CONSTANTS.CUSTOM ? plan.plan : plan.name,
          price: plan.price,
          description: plan.description,
        }}
        belongsTo={belongsTo}
      />
      <EndpointContainers
        plan={plan}
        isAsync={isAsync}
        allEndpoints={allEndpoints}
        instanceIdVersionMap={instanceIdVersionMap}
      />
    </div> : 
    displaySubscriptionLocationPlanTile({plan})
      
  );
};

const PlanDetails = ({ details }) => {
  return (
    <div className="api-dir-pkg_advance-plan-description-container">
      <h1 className="api-dir-pkg_advance-plan-title">{`${details.type}`}</h1>
      <h1 className="api-dir-pkg_advance-plan-pricing">
        {`$${details.price?.toLocaleString('en-US', {
          minimumFractionDigits: 2
        })} / `}{' '}
        <span style={{ fontSize: '14px' }}>
          month
        </span>
      </h1>
      <h3 className="api-dir-pkg_advance-plan-description">{details?.description}</h3>
    </div>
  );
};

const EndpointContainers = ({
  plan,
  isAsync,
  allEndpoints,
  instanceIdVersionMap
}) => {
  const [expandedContainer, setExpandedContainer] = useState(false);

  const onExpanded = index => {
    setExpandedContainer(expandedContainer === index ? null : index);
  };

  return (
    <div className="api-dir-pkg_advance-plan-endpoint-container">
      {plan.containers?.map((container, index) => (
        <Container
          pricingDetails={{
            title: container.name,
            quota: container.quota,
            overage: container.overage,
            endpoints: container.endPoints,
            channels: container.channels,
            isFree: container?.isFree
          }}
          index={index}
          key={index}
          isExpanded={index === expandedContainer}
          onExpanded={index => onExpanded(index)}
          allEndpoints={allEndpoints}
          isAsync={isAsync}
          instanceIdVersionMap={instanceIdVersionMap}
        />
      ))}
    </div>
  );
};

const Container = ({
  pricingDetails: { title, quota, overage, endpoints, channels, isFree },
  index,
  onExpanded,
  isExpanded,
  isAsync,
  allEndpoints = [],
  instanceIdVersionMap
}) => {
  const paths = isAsync ? channels : endpoints;
  const containerEndpoints =
    paths && paths.length
      ? constructEndpointTitle(paths, instanceIdVersionMap)
      : allEndpoints;

  const callsPerMonthText = `${isFree ? 'Unlimited' : formatNumbers(quota)
    } free calls per month`;

  const overageText = `$${overage} overage fee`;

  return (
    <div>
      <div className="api-dir-pkg_advance-plan-enpoint-container-label">{title}</div>
      <pre className="api-dir-pkg_advance-plan-container-quota-overage">
        {callsPerMonthText} <br />
        {overageText}
      </pre>
      <IconArrowCascadeRight
        onClick={() => onExpanded(index)}
        className={
          isExpanded ? 'api-dir-pkg_advance-plan-arrow-rotate' : 'api-dir-pkg_advance-plan-arrow'
        }
      />
      {isExpanded && (
        <div className={'api-dir-pkg_advance-plan-endpoint-list'}>
          {containerEndpoints.map((endpoint, index) => (
            <h3 key={index} className="api-dir-pkg_advance-plan-endpoint-name">
              {endpoint}
            </h3>
          ))}
        </div>
      )}

      <div className="api-dir-pkg_advance-plan-divider" />
    </div>
  );
};

const constructEndpointTitle = (endpoints, instanceIdVersionMap) => {
  return endpoints.map((ep) => {
    let desc = ep.summary || ep.route?.replace('/', '');
    return `${ep?.verb?.padEnd(9, ' ')} ${instanceIdVersionMap?.find(
      f => f.apiInstanceId === ep.apiInstanceId
    )?.version || ''}-${desc}`;
  });
};
